import React, { useContext } from 'react';
import AppContext from '@context';
import { FuelCallout, FuelTypography } from '@frete.com/fuel-react';
import useAmplitude from '@hooks/useAmplitude';
import { pageLinkOpen } from '@helpers/journeys/pageLinkOpen';
import { translateReason } from '@utils/translateReason';
import * as Styled from './DisclaimersStyles';
import { Section } from '../ModalMonitoringStyles';

function Disclaimers() {
  const {
    state: {
      journeys: { selection: journeySelection },
    },
  } = useContext(AppContext);
  const { amplitudeEvent } = useAmplitude();
  const disclaimers: React.ReactNode[] = [];

  if (!journeySelection.data?.journey) {
    return null;
  }

  const reasonSlug = journeySelection.data.journey.status.details.reason;
  const translatedReason = reasonSlug
    ? `Motivo: ${translateReason(reasonSlug)}`
    : undefined;

  if (
    journeySelection.data.journey.status.slug === 'unrecognized' &&
    journeySelection.data.journey.status.details.updatedBy === 'trucker'
  ) {
    disclaimers.push(
      <Styled.WrapperDisclaimer>
        <FuelCallout
          data-testid="fuelCallout-journey-unrecognized-trucker"
          heading="Viagem não reconhecida pelo motorista"
          message={translatedReason}
          color="red"
          icon="cancel"
          iconShape
          fullWidth
        />
      </Styled.WrapperDisclaimer>,
    );
  }

  if (
    journeySelection.data.journey.status.slug === 'unrecognized' &&
    journeySelection.data.journey.status.details.updatedBy === 'company'
  ) {
    disclaimers.push(
      <Styled.WrapperDisclaimer>
        <FuelCallout
          data-testid="fuelCallout-journey-unrecognized-company"
          heading="Esta viagem não foi reconhecida"
          message={translatedReason}
          color="red"
          icon="cancel"
          iconShape
          fullWidth
        />
      </Styled.WrapperDisclaimer>,
    );
  }

  if (
    journeySelection.data.journey.status.slug === 'canceled' &&
    journeySelection.data.journey.status.details.updatedBy === 'trucker'
  ) {
    disclaimers.push(
      <Styled.WrapperDisclaimer>
        <FuelCallout
          data-testid="fuelCallout-journey-canceled-trucker"
          heading="Viagem cancelada pelo motorista"
          message={translatedReason}
          color="red"
          icon="cancel"
          iconShape
          fullWidth
        />
      </Styled.WrapperDisclaimer>,
    );
  }

  if (
    journeySelection.data.journey.status.slug === 'canceled' &&
    journeySelection.data.journey.status.details.updatedBy === 'company'
  ) {
    disclaimers.push(
      <Styled.WrapperDisclaimer>
        <FuelCallout
          data-testid="fuelCallout-journey-canceled-company"
          heading="Viagem cancelada pela empresa"
          message={translatedReason}
          color="red"
          icon="cancel"
          iconShape
          fullWidth
        />
      </Styled.WrapperDisclaimer>,
    );
  }

  if (journeySelection.data.page.disclaimer.description) {
    disclaimers.push(
      <Styled.WrapperDisclaimer>
        <FuelCallout
          data-testid="fuelCallout-journey-gr"
          icon={journeySelection.data.page.disclaimer.icon || undefined}
          iconStyle="filled"
          fullWidth
          color="blue"
        >
          <FuelTypography slot="content" size="caption" weight="medium">
            {journeySelection.data.page.disclaimer.description}
            {journeySelection.data.page.disclaimer.link && (
              <FuelTypography displayInline spacingLeft={5} size="caption">
                <Styled.WrapperLink
                  data-testid="link-landing-page"
                  onClick={() => {
                    amplitudeEvent('journey_know_more_for_landing_page', {
                      source: 'monitorar-viagem-saiba-mais',
                      journey_id: journeySelection.data?.journey.id || '',
                    });
                    pageLinkOpen(journeySelection.data?.page.disclaimer.link);
                  }}
                >
                  Saiba mais
                </Styled.WrapperLink>
              </FuelTypography>
            )}
          </FuelTypography>
        </FuelCallout>
      </Styled.WrapperDisclaimer>,
    );
  }

  if (!disclaimers.length) {
    return null;
  }

  return <Section gap="km6">{disclaimers}</Section>;
}

export default Disclaimers;
